import { render, staticRenderFns } from "./RecordButton.vue?vue&type=template&id=14c9e989&scoped=true&"
import script from "./RecordButton.vue?vue&type=script&lang=js&"
export * from "./RecordButton.vue?vue&type=script&lang=js&"
import style0 from "./RecordButton.vue?vue&type=style&index=0&id=14c9e989&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c9e989",
  null
  
)

export default component.exports